<script context="module">
    import { currentUser, selectedItem, displayDetailedRating, ratingLoading } from '../store/store.js';
    import Logotype from './Logotype.svelte';

    // Översättningstabell för rating-nycklar
    const ratingKeyTranslations = {
        overall_rating: 'Helhetsbetyg',
        loans_per_sqm_rating: 'Lån',
        saving_per_sqm_rating: 'Sparande',
        solidity_rating: 'Soliditet',
        rental_income_from_commercial_premises_per_sqm_rating: 'Affärsintäkter',
        living_fee_per_sqm_rating: 'Avgifter', // Antaget namn, anpassa vid behov
        living_area_sqm_rating: 'Boarea',
        number_of_apartments_rating: 'Antal lägenheter',
        commercial_area_sqm_rating: 'Affärsarea',
        liquid_assets_per_sqm_rating: 'Likvida tillgångar',
        energy_cost_per_sqm_rating: 'Energikostnader',
        operating_expenses_per_sqm_rating: 'Driftskostnader',
        profit_after_financial_items_rating: 'Resultat',
        owns_the_land_rating: 'Markägande',
        genuine_house_association_rating: 'Äkta förening',
    };

    // Funktion för att hämta översättning eller formatera nyckel
    function getTranslatedKey(key) {
        return ratingKeyTranslations[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }

    function calculateStars(rating) {
        return Math.round((rating / 100) * 10); // Convert 100 scale to 5 stars
    }

    // src/utils/ratingUtils.js
    export async function rateBrf(coreId) {
        ratingLoading.set(true);
        let url = 'https://boanalys-backend-324523837899.europe-north1.run.app/rate_brf';
        const queryParams = new URLSearchParams({ core_id: coreId });
        const response = await fetch(`${url}?${queryParams.toString()}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${currentUser?.accessToken}`,
        },
        });
    
        if (!response.ok) {
        throw new Error('Failed to trigger backend function');
        }
    
        console.log('Rated core_id:', coreId);
        ratingLoading.set(false);
        return coreId;
    }

	function getSortedRatings(ratingObj, overall_rating) {
		if (!Object.entries) {
			Object.entries = function(obj) {
				return Object.keys(obj).map(key => [key, obj[key]]);
			};
		}
		let ratings = Object.entries(ratingObj);
		if (overall_rating === true) {
			ratings = ratings.map(([key, value]) => ({ key, ...value })).filter(item => item.rating !== undefined && item.rating !== null);
		}
		else {
			ratings = ratings.map(([key, value]) => ({ key, ...value })).filter(item => item.rating !== undefined && item.rating !== null && item.key !== "overall_rating");

		}
		ratings = ratings.sort((a, b) => b.rating - a.rating);
        return ratings;
    }

    function toggleDetails() {
        displayDetailedRating.update(value => !value);
    }
</script>

{#if $selectedItem?.rating}
<div class="key-value-table box">
    <div class="metric-card rating-card">
        <div class="metric-header">
            <h6>{getTranslatedKey('overall_rating')}</h6>
            <!-- Optional: Add info icon/tooltip later if needed -->
        </div>
        <div class="stars">
            {#each Array(5) as _, i}
                {#if $selectedItem.rating.overall_rating && i < Math.floor(calculateStars($selectedItem.rating.overall_rating.rating || 0) / 2)}
                <!-- Full star -->
                <div class="star filled"></div>
                {:else if $selectedItem.rating.overall_rating && i === Math.floor(calculateStars($selectedItem.rating.overall_rating.rating || 0) / 2) && calculateStars($selectedItem.rating.overall_rating.rating || 0) % 2 !== 0}
                <!-- Half star -->
                <div class="star half-filled"></div>
                {:else}
                <!-- Empty star -->
                <div class="star"></div>
                {/if}
            {/each}
        </div>
        <div class="metric-value overall_rating">
            {$selectedItem.rating.overall_rating ? $selectedItem.rating.overall_rating.rating : "--"}
            <span class="rating-scale"> / 100</span>
        </div>
        <div class="explanation_rating">
            <p>{$selectedItem.rating.overall_rating ? getSortedRatings($selectedItem.rating, true).find(r => r.key === 'overall_rating')?.reason || "" : ""}</p>
            <button class="action-button" on:click={toggleDetails}>
                {#if $displayDetailedRating}Dölj detaljer{:else}Visa detaljer{/if}
            </button>
            {#if $displayDetailedRating}
                <div class="detailed-ratings">
                    {#each getSortedRatings($selectedItem.rating, false) as item}
                        <div class="detailed-rating-item">
                            <strong>{getTranslatedKey(item.key)}:</strong>
                            <span class="rating-value">{item.rating} / 100</span>
                            <span style="margin-left: 5px; margin-right: 5px;">{item.reason}</span>
                        </div>
                    {/each}
                </div>
            {/if}
        </div>
    </div>
</div>
{/if}
{#if !$selectedItem?.rating && $ratingLoading === true}
<div class="key-value-table box">
    <div class="metric-card rating-card loading-card">
        <h6 style="text-align: center; margin-bottom: 15px;">Betygsättning pågår...</h6>
        <div class="loading-analysis">
            <Logotype />
        </div>
    </div>
</div>
{:else if !$selectedItem?.rating && !$ratingLoading}
<div class="key-value-table box">
    <div class="metric-card rating-card missing-rating-card">
        <h5 style="text-align: center; margin-bottom: 15px;">Betyg saknas</h5>
        <p style="text-align: center; font-size: 0.9rem; color: #6c757d;">Betygsättningen gick fel och kan ta ett par dagar att åtgärdas.</p>
        <!-- Optional: Add an icon or visual element here if desired -->
    </div>
</div>
{/if}


<style>
    .key-value-table.box {
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 4px 0 rgba(4, 4, 52, .06), 0 0 2px 0 rgba(91, 95, 107, .24);
        padding: 20px 20px 16px 20px;
        transition: box-shadow 0.3s ease;
        display: flex;
        min-height: 0;
    }

    .key-value-table.box:hover {
        box-shadow: 0 8px 12px 0 rgba(4, 4, 52, 0.1), 0 0 4px 0 rgba(91, 95, 107, 0.3);
    }

    .metric-card {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 16px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        flex-grow: 1;
        box-sizing: border-box;
    }

    .metric-header {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 12px;
    }

    .metric-header h6 {
        margin: 0;
        font-size: 0.9rem;
        color: #666;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .stars {
        display: flex;
        gap: 5px;
        justify-content: center;
        margin-bottom: 10px;
    }

    .star {
        width: 28px;
        height: 28px;
        background-color: #ddd;
        clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    }

    .star.filled {
        background-color: gold;
    }

    .star.half-filled {
        background: linear-gradient(90deg, gold 50%, #ddd 50%);
    }

    .metric-value.overall_rating {
        font-size: 10rem;
        font-weight: 700;
        color: #333;
        line-height: 1;
        margin-bottom: 30px;
        margin-top: 10px;
    }

    .rating-scale {
        font-size: 1.5rem;
        font-weight: 400;
        color: #6c757d;
        margin-left: -40px;
    }

    .explanation_rating {
        font-size: 0.95rem;
        color: #495057;
        line-height: 1.6;
        max-width: 90%;
        text-align: center;
    }

    .explanation_rating p {
        margin-bottom: 15px;
    }

    .detailed-ratings {
        margin-top: 20px;
        text-align: left;
        border-top: 1px solid #e9ecef;
        padding-top: 15px;
    }

    .detailed-rating-item {
        margin-bottom: 15px;
        font-size: 0.8rem;
        color: #495057;
        line-height: 1.5;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: baseline;
    }

    .detailed-rating-item strong {
        color: #343a40;
        margin-right: 10px;
        flex-shrink: 0;
    }

    .rating-value {
        font-weight: 500;
        color: #333;
        text-align: right;
    }

    .detailed-rating-item span:last-of-type {
        color: #6c757d;
        margin-top: 4px;
        width: 100%;
        flex-basis: 100%;
        text-align: left;
    }

    .loading-card {
        padding: 30px 16px;
    }

    .loading-analysis {
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.7;
    }

    .loading-analysis :global(svg) {
        width: 60px;
        height: auto;
    }

    .missing-rating-card {
        padding: 30px 16px;
        min-height: 150px; /* Ensures minimum height */
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
</style>
